import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import useTransactionsStore from '@/store/modules/transactions';
import { TransactTypes } from '@/types/transact';
import router from '@/router';
export default defineComponent({
    name: 'MinipayAuthorizationFailed',
    props: {},
    components: {
        Button,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { selectedCrypto, currentStep } = storeToRefs(transactionStore);
        const onKeyPress = () => {
            console.log();
        };
        function goHome() {
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        }
        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        const failedDate = `${day}/${month.toString().padStart(2, '0')}/${year.toString().slice(2)}`;
        return {
            onKeyPress,
            selectedCrypto,
            goHome,
            failedDate,
        };
    },
});
